var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SegmentedControl',{staticClass:"m-b-20 accounts-primary-tabs",attrs:{"aria-label":"Finance control section","value":_vm.changeTab,"options":[
    {
      label: 'Jobs Payment Detail',
      value: 'paymentDetail',
      icon: 'work_outline',
    },
    {
      label: 'Assignment Payment Details',
      value: 'advanceDetail',
      icon: 'assignment',
    } ]},on:{"change":_vm.filterByTab}})}
var staticRenderFns = []

export { render, staticRenderFns }